import { Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GetMenuWebService } from '../../services/web/get-menus-web.service';
import { CommonModule } from '@angular/common';
import { IMenusAPIResponse } from '../../models/web/IMenusAPIResponse';
import { catchError, map, Observable, of } from 'rxjs';
@Component({
	selector: 'app-footer',
	standalone: true,
	imports: [RouterLink, CommonModule],
	templateUrl: './footer.component.html',
	styleUrl: './footer.component.scss'
})
export class FooterComponent {
	@Input({ required: true }) menuRutasFrecuentes1?: any[];
	@Input({ required: true }) menuRutasFrecuentes2?: any[];
	@Input({ required: true }) menuEnlaces?: any[];
	@Input({ required: true }) menuEnlaces2?: any[];
	error: string | null = null;
	anioActual = new Date().getFullYear();
	ngOnInit() {
		// this.filteredMenus$ = this._menusApiResource.getmenus().pipe(
		// 	map((menus) => menus.filter((menu) => menu.nombre === 'Menú enlaces')),
		// 	catchError((error) => {
		// 		this.error = 'Hubo un problema al cargar los menús. Por favor, intenta de nuevo más tarde.';
		// 		console.error('Error fetching menus:', error);
		// 		return of([]);
		// 	})
		// );
	}
}
